// 货币
export const enum Currency {
  ID = 'IDR',
  MY = 'MYR',
  PH = 'PHP',
  TH = 'THB',
  VN = 'VND',
  SG = 'SGD',
  GB = 'GBP',
  US = 'USD',
  ES = 'EUR',
  MX = 'MXN',
  DE = 'EUR',
  IT = 'EUR',
  FR = 'EUR',
  GLOBAL = 'USD'
}

export function isValidCurrency(currency?: string): currency is Currency {
  if (currency === undefined) {
    return false
  }

  return (
    [
      Currency.ID,
      Currency.MY,
      Currency.PH,
      Currency.TH,
      Currency.VN,
      Currency.SG,
      Currency.GB,
      Currency.US,
      Currency.GLOBAL,
      Currency.ES,
      Currency.MX,
      Currency.DE,
      Currency.IT,
      Currency.FR
    ] as string[]
  ).includes(currency)
}
